var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420 -85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,1A2,2,0,0,0,1,3V8a2,2,0,0,0,2,2h9V3a2,2,0,0,0-2-2H3M3,0h7a3,3,0,0,1,3,3v8H3A3,3,0,0,1,0,8V3A3,3,0,0,1,3,0Z",
    transform: "translate(420 85)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.832.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.832a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.832.5Z",
    transform: "translate(423.584 89)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.832.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.832a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.832.5Z",
    transform: "translate(423.584 92)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/interview.c2852b92510a6a3cae9979cbd70d42d6.svg";
export { ForwardRef as ReactComponent };